import router from "@/router";
import store from "@/store";

router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = to.meta.title
    }
    if (to.matched.length === 0) {
        //如果未匹配到路由
        next('/Error')
            //from.name ? next({ name: from.name }) : next('/');
            //如果上级也未匹配到路由则跳转登录页面，如果上级能匹配到则转上级路由
    }
    let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    flag ? store.commit('equipment/setEquipment', 'mobile') : store.commit('equipment/setEquipment', 'computer');
    next();
})